import React, { useState, useEffect } from 'react'
import useAuthentication from '../../lib/use-authentication'

function IsLoggedInNative() {
  const { loginState, _dispatchLoginStateChange } = useAuthentication()
  const { loggedIn } = loginState
  const [shouldRender, setShouldRender] = useState(loggedIn)

  useEffect(() => {
    setShouldRender(loggedIn)
  }, [loggedIn])

  if (!shouldRender) return null

  return (
   <div
      style={{ display: 'none' }}
      data-controller="native-is-logged-in"
    />
  )
}

export default IsLoggedInNative
